import { render, staticRenderFns } from "./ChoiceResponseTemplate.vue?vue&type=template&id=3b24c7a2&"
import script from "./ChoiceResponseTemplate.vue?vue&type=script&lang=js&"
export * from "./ChoiceResponseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceResponseTemplate.vue?vue&type=style&index=0&id=3b24c7a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports